import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as innovationIdea from '../innovation-idea'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: innovationIdea.RESOURCE.payload.dimension.partialId,
      partialId: innovationIdea.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The current status of the innovation idea.',
    isOptional: true,
    name: 'Status',
    partialId: PartialId.Standard.create('status'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
